import { Slider } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
function PoloRating({
  playerRating,
  setPlayerRating,
  disabled,
}: {
  playerRating: number;
  setPlayerRating: Dispatch<SetStateAction<number>>;
  disabled: boolean;
}) {
  const playerRatings = [];
  // Add half ratings between -2 and 2 with empty labels
  for (var i = -2; i <= 2; i += 0.5) {
    playerRatings.push({
      value: i,
      label: Number.isInteger(i) ? i : "", // Only show labels for whole numbers
    });
  }
  // Add remaining whole numbers from 3 to 10
  for (i = 3; i <= 10; i++) {
    playerRatings.push({ label: i, value: i });
  }
  return (
    <Slider
      aria-label="Polo Rating"
      data-testid="polo-rating"
      disabled={disabled}
      value={playerRating}
      step={playerRating < 2 ? 0.5 : 1}
      min={-2}
      max={10}
      onChange={(event, newValue) => {
        setPlayerRating(newValue as number);
      }}
      valueLabelDisplay="auto"
      marks={playerRatings}
    />
  );
}

export default PoloRating;
